import Header from "@/components/Header";
import BackToTopButton from "@/components/BackToTopButton";
import HeroSection from "@/components/HeroSection";
import HeroContent from "@/components/HeroContent";
import ServicesSection from "@/components/ServicesSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ClientsSection from "@/components/ClientsSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import StructuredData from "@/components/StructuredData";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        path="/"
      />
      <StructuredData />
      <Header />
      <main>
        <HeroSection />
        <div className="relative z-10 bg-background overflow-x-clip">
          <HeroContent />
          <ServicesSection />
          <TestimonialsSection />
          <ClientsSection />
          <CTASection />
          <BackToTopButton />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
